import React from 'react'
import "../../../Styles/OurApproach.scss"
import MobileViewourapproach from "../../../Assests/MobileViewOurPlatform/MobileViewOurApproach.jpg"
import coreapproach from "../../../Assests/OurPlatform/coreapproach.png"
import MobileViewHealthJourney from "../../../Assests/MobileViewOurPlatform/MobileViewHealthJourney.png"


function MobileViewOurApproach() {
  return (
    <div className='mobileviewourapproach  mt-3 pt-4'>
      <div className=' pt-5'>
            <div class="mobileviewourapproach-container">
        <img src={MobileViewourapproach} alt="wourapproach" style={{width:"100%"}}/>
       
        <div class="mobileview-ourapproach-centered p-2">
            <div className='fw-bold missionandvisiontextcolor fs-3'>
            Our Approach: Personalized & Holistic Healthcare Approach
            </div>
        </div>

        <div class="mobileview-current-medical-centered">
            <div className='fw-bold personalized-text-gradient fs-6' >
                    Current medical practice : Reactive
            </div>
        </div>

        <div class="mobileview-current-healthcare-centered">
            <div className='w-75 m-auto' style={{fontSize:".66rem"}}>
            Current healthcare is often reactive, treating symptoms only after they appear 
            and focusing on managing conditions rather than preventing them—much like addressing 
            only the tip of an iceberg without tackling underlying causes.
            </div>
        </div>


        <div class="mobileview-vizzhy-approach-centered">
            <div className='fw-bold personalized-text-gradient fs-6 w-75 text-start' >
            Vizzhy’s Approach: Proactive
            </div>
        </div>

        <div class="mobileview-vizzhy-approach-content-centered">
            <div className=' text-start' style={{fontSize:".66rem",width:"55%"}}>
            At Vizzhy, we take a proactive approach using multi-omics analysis to study DNA, proteome, 
            metabolome, and microbiome detecting early health risks at a molecular level. 
            IoT devices provide real-time monitoring while generative AI predicts outcomes based on 
            individual metabolic profiles enabling personalized treatments. 
            This technology helps us treat and prevent disease recurrence enhancing long-term health and quality of life.
            </div>
        </div>

        
        </div>

        <div>

        </div>

      </div>



        <div className='main-background'>
            <div className='d-flex justify-content-center pt-5'>
                <div className='fs-3 fw-bold'>
                <div className='d-flex justify-content-center ' style={{ color: "#9367B1" }}>P5 Medicine :</div>
                <div>The Core of Our Approach</div>
                </div>
                
            </div>

            <div className='w-75 m-auto text-center pt-3 '>
            (P5 Medicine - Predictive, Preventive, Precision, Participatory and Personalized)
            </div>

            <div className='w-75 m-auto text-center pt-3'>
            P5 Medicine drives our healthcare approach, emphasizing Predictive, 
            Preventive, Precision, Participatory, and Personalized care. 
            Using multi-omics and Gen-AI, we deliver tailored, proactive health solutions for lasting well-being.
            </div>

            <div className='d-flex justify-content-center p-3 pt-5 pb-5'>
            <img src={coreapproach} alt="Nature" class="core-approach-img" style={{width:"100%"}}/>
            </div>

            <div className='health-journey'>
                    <div className=' missionandvisiontextcolor fw-bold fs-4 d-flex justify-content-center pt-5'>
                    Your Personalized Health Journey
                    </div>

                    <div className=' pt-5 pb-5'>
                        <img src={MobileViewHealthJourney} alt="Nature" class="core-approach-img" style={{width:"100%"}}/>
                    </div>
            </div>
        </div>

      {/* <div className='core-approach main-background'>
          <div className='container pt-5'>
            <div className='row w-100 fs-1 fw-bold  pt-5 who-we-are-heading'>
              <div className='col-md-5 text-end' style={{ color: "#9367B1" }}>P5 Medicine :</div>
              <div className='col-md-7 '>The Core of Our Approach</div>
            </div>
            <div className='row w-100  justify-content-center mt-3 fs-4 p5-medicine'>(P5 Medicine - Predictive, Preventive, Precision, Participatory and Personalized) </div>

            <div className='m-auto d-flex text-center m-auto  justify-content-center mt-3 fs-4  p5-medicine-drivers'>
              P5 Medicine drives our healthcare approach, emphasizing Predictive,
              Preventive, Precision, Participatory, and Personalized care.
              Using multi-omics and Gen-AI, we deliver tailored, proactive health solutions for lasting well-being.
            </div>
          </div>

          <div className='p-5 mt-5'>
            <img src={coreapproach} alt="Nature" class="core-approach-img" />
          </div>
        </div>

      <div className='health-journey '>
        <div className='container '>
          <div className='row w-100 justify-content-center fw-bold missionandvisiontextcolor pt-5 personalized-health-main-text' style={{ fontSize: "3.5rem" }}>
            Your Personalized Health Journey</div>
        </div>

        <div>
          <img src={MobileViewHealthJourney} alt="Nature" class="core-approach-img" />
        </div>
      </div> */}
    </div>
  )
}

export default MobileViewOurApproach